import * as React from 'react';
import Header from '../Header';
import { DECADE_DISTANCE_COUNT } from '.';
import PanelContext from '../../PanelContext';
function DecadeHeader(props) {
    const { prefixCls, generateConfig, viewDate, onPrevDecades, onNextDecades, } = props;
    const { hideHeader } = React.useContext(PanelContext);
    if (hideHeader) {
        return null;
    }
    const headerPrefixCls = `${prefixCls}-header`;
    const yearNumber = generateConfig.getYear(viewDate);
    const startYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
    const endYear = startYear + DECADE_DISTANCE_COUNT - 1;
    return (<Header {...props} prefixCls={headerPrefixCls} onSuperPrev={onPrevDecades} onSuperNext={onNextDecades}>
            {startYear}-{endYear}
        </Header>);
}
export default DecadeHeader;
